import { useEquipment } from "../../hooks/queries/equipment/useEquipments"

import * as Styled from "./EquipmentDocumentList.styled"

export const EquipmentDocumentList = (props) => {
    const { equipmentId } = props

    const { data } = useEquipment(equipmentId)

    return <Styled.List documents={data?.documents} />
}